<!-- eslint-disable max-len -->
<template>
  <div>
    <Card title="User Management">
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="mr-2">
                <el-input placeholder="search name" v-model="filter.q" @change="searchUser" ></el-input>
              </div>
              <div class="mr-2">
                <el-select v-model="filter.type" filterable placeholder="Select Type" >
                  <el-option :value="0" :key="0" label="Free"></el-option>
                  <el-option :value="1" :key="1" label="Subscriber"></el-option>
                </el-select>
              </div>
              <div class="mr-2">
                <el-select v-model="filter.country_code" filterable placeholder="Select Country" >
                  <el-option :value="c.id" :key="c.id" :label="c.label" v-for="c in dataCountries"></el-option>
                </el-select>
              </div>
              <Button @clicked="searchUser" label="Apply"/>
              <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="reset" /></button>
            </div>
            <download-excel
              class="md:w-50"
              :data="data"
              :fields="excel_fields"
              :meta="excel_meta"
              worksheet="My Worksheet"
              name="users.xls"
            >
              <div v-bind:class="'bg-indigo-500 text-gray-100'" class="flex items-center px-4 py-3 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
                <p class="m-auto text-xs font-medium">
                  Download Excel
                </p>
              </div>
            </download-excel>
          </div>
        </div>

        <data-tables-server ref="tableUser" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [20,50,100,300,500] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom" :width="title.prop.width">
          </el-table-column>
          <el-table-column v-if="isSuperAdmin || isAdmin || isOps" label="Actions" align="right" width="200px" fixed="right">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip v-if="scope.row.email_verified_at===null" label="Resend Email" :position="'is-right'">
                  <button @click="resendEmail(scope.row)" class="p-2 w-8 mr-2 rounded bg-orange-500 hover:bg-orange-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'envelope-square']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip label="Detail" :position="'is-left'">
                  <button @click="detailUser(scope.row)" class="p-2 w-8 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="scope.row.statusCode!==2" label="Block" :position="'is-left'">
                  <button @click="blockUser($event, scope.row)" class="p-2 w-8 mr-2 rounded bg-red-700 hover:bg-red-800 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'ban']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="scope.row.statusCode===2" label="Unblock" :position="'is-left'">
                  <button  @click="unBlockUser($event, scope.row)" class="p-2 w-8 mr-2 rounded bg-green-400 hover:bg-green-500 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'circle-notch']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="!isOps" label="Delete" :position="'is-left'">
                  <button @click="deleteUser($event, scope.row)"  class="w-8 mr-2 p-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                  </button>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
    <ModalDialogDetail
      :isShowingModal="isShowingModal"
      :isLoading="isLoading"
      title="Detail User"
      @toggleModal="toggleModal()"
      size="large"
    >
      <template slot="body" >
        <div class="w-full p-2 modal-content">
          <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
            <li class="-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer ">
              <a class=" text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabsUserDetail(1)" v-bind:class="{'text-blue-500 bg-white': userDetailOpenTab !== 1, 'text-white bg-blue-500': userDetailOpenTab === 1}">
                Detail
              </a>
            </li>
            <li class="-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer ">
              <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabsUserDetail(2)" v-bind:class="{'text-blue-500 bg-white': userDetailOpenTab !== 2, 'text-white bg-blue-500': userDetailOpenTab === 2}">
                Song Purchased
              </a>
            </li>
            <li class="-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer ">
              <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabsUserDetail(3)" v-bind:class="{'text-blue-500 bg-white': userDetailOpenTab !== 3, 'text-white bg-blue-500': userDetailOpenTab === 3}">
                Album Purchased
              </a>
            </li>
          </ul>
          <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded" style="">
            <div class="px-4 py-5 flex-auto">
              <div class="tab-content tab-space">
                <div v-bind:class="{'hidden': userDetailOpenTab !== 1, 'block': userDetailOpenTab === 1}" class="mx-400 ">
                  <div class="tab-user">
                    <div class="flex flex-col md:flex-row pb-4 px-20">
                      <div class="flex-1 flex flex-col md:flex-row">
                        <div class="w-full flex-1 mx-2">
                          <div class="my-2 p-1 flex">
                            <img :src="user.avatar" width="100" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex flex-col md:flex-row border-b border-gray-200">
                      <div class="w-32 text-left font-bold h-6 mx-2 mt-3 text-gray-800">Full Name</div>
                      <div class="flex-1 flex flex-col md:flex-row">
                        <div class="w-full flex-1 mx-2">
                          <div class="my-2 p-1 flex">
                            <p>{{ user.name }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex flex-col md:flex-row border-b border-gray-200">
                      <div class="w-32 text-left font-bold h-6 mx-2 mt-3 text-gray-800">Email</div>
                      <div class="flex-1 flex flex-col md:flex-row">
                        <div class="w-full flex-1 mx-2">
                          <div class="my-2 p-1 flex">
                            <p>{{ user.email }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex flex-col md:flex-row border-b border-gray-200">
                      <div class="w-32 text-left font-bold h-6 mx-2 mt-3 text-gray-800">Country</div>
                      <div class="w-full flex-1 mx-2">
                        <div class="flex-1 flex flex-col md:flex-row">
                          <div class="my-2 p-1 flex">
                            <p>{{ user.country_name }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex flex-col md:flex-row border-b border-gray-200">
                      <div class="w-32 text-left font-bold h-6 mx-2 mt-3 text-gray-800">Status</div>
                      <div class="flex-1 flex flex-col md:flex-row">
                        <div class="w-full flex-1 mx-2">
                          <div class="my-2 p-1 flex">
                            <p>{{ user.status }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex flex-col md:flex-row border-b border-gray-200">
                      <div class="w-32 text-left font-bold h-6 mx-2 mt-3 text-gray-800">Type</div>
                      <div class="flex-1 flex flex-col md:flex-row">
                        <div class="w-full flex-1 mx-2">
                          <div class="my-2 p-1 flex">
                            <p>{{ user.type==0?'Free':'Subscriber' }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <data-tables :layout="'table'" :data="user.devices" :total="user.devices.length" :pagination-props="{ pageSizes: [100] }">
                      <el-table-column v-for="title in titlesDevice" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
                      </el-table-column>
                    </data-tables>
                  </div>
                </div>
                <div v-bind:class="{'hidden': userDetailOpenTab !== 2, 'block': userDetailOpenTab === 2}" class="mx-400 ">
                  <div class="pb-6 flex justify-between items-center">
                    <div class="flex items-center">
                      <div class="mr-2">
                        <el-input placeholder="search song" v-model="qwordSong" @change="searchSong" ></el-input>
                      </div>
                      <Button @clicked="searchSong" label="Apply"/>
                      <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="resetSong" /></button>
                    </div>
                  </div>
                  <data-tables-server ref="tableSong" :data="dataSong" :total="totalSong" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTableSong" >
                    <el-table-column v-for="title in titlesSong" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
                    </el-table-column>
                  </data-tables-server>
                </div>
                <div v-bind:class="{'hidden': userDetailOpenTab !== 3, 'block': userDetailOpenTab === 3}" class="mx-400 ">
                  <div class="pb-6 flex justify-between items-center">
                    <div class="flex items-center">
                      <div class="mr-2">
                        <el-input placeholder="search album" v-model="qwordSong" @change="searchAlbum" ></el-input>
                      </div>
                      <Button @clicked="searchSong" label="Apply"/>
                      <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="resetAlbum" /></button>
                    </div>
                  </div>
                  <data-tables-server ref="tableAlbum" :data="dataAlbum" :total="totalAlbum" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTableAlbum" >
                    <el-table-column v-for="title in titlesAlbum" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
                    </el-table-column>
                  </data-tables-server>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </ModalDialogDetail>
  </div>
</template>
<script>
import { Button } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ModalDialogDetail from '../components/Common/ModalDialogDetail';
import { ViewProfile } from '../components/Profile';
import JsonExcel from 'vue-json-excel';
import moment from 'moment';
import helpersMixins from '@/mixins/helpers.mixins';

Vue.component('downloadExcel', JsonExcel);
export default {
  name: 'UsersPage',
  mixins: [helpersMixins],
  data() {
    return {
      excel_fields: {
        'User Id': 'id',
        Name: 'name',
        Email: 'email',
        Device: 'devices',
        'Created At': 'created_at',
        'Email Verified At': 'email_verified_at',
      },
      excel_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8',
          },
        ],
      ],
      isLoading: false,
      isShowingModal: false,
      userDetailOpenTab: 1,
      displayingItem: 20,
      detailUserId: null,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      total: 0,
      page: 1,
      titles: [{
        prop: {
          field: 'name',
          width: '250',
        },
        label: 'Name',
      }, {
        prop: {
          field: 'email',
          width: '250',
        },
        label: 'Email',
      }, {
        prop: {
          field: 'status',
          width: '100px',
        },
        label: 'Status',
      }, {
        prop: {
          field: 'devices',
          width: '105px',
        },
        label: 'Device',
      }, {
        prop: {
          field: 'country_name',
          width: '135px',
        },
        label: 'Country',
      }, {
        prop: {
          field: 'created_at',
          width: '140px',
        },
        label: 'Created At',
      }, {
        prop: {
          field: 'type_user',
          width: '135px',
        },
        label: 'Type',
      }, {
        prop: {
          field: 'email_verified_at',
          width: '135px',
        },
        label: 'Verified At',
      }, {
        prop: {
          field: 'verification_last_sent',
          width: '135px',
        },
        label: 'Resend At',
      }],
      titlesDevice: [{
        prop: 'app_build',
        label: 'App Build',
      }, {
        prop: 'app_version',
        label: 'App Version',
      }, {
        prop: 'platform',
        label: 'Platform At',
      }, {
        prop: 'os_version',
        label: 'OS Version',
      }, {
        prop: 'device_id',
        label: 'Device ID',
      }, {
        prop: 'model',
        label: 'Model',
      }, {
        prop: 'is_login',
        label: 'Is Login',
      }, {
        prop: 'created_at',
        label: 'Created At',
      }, {
        prop: 'updated_at',
        label: 'Updated At',
      }],
      filter: {
        per_page: 20,
        page: 1,
        q: '',
        type: '',
        country_code: '',
      },
      qwordAlbum: '',
      qwordSong: '',
      filterAlbum: {
        per_page: 20,
        page: 1,
        q: '',
        sortby: 'transaction.id',
        sortorder: 'desc',
      },
      filterSong: {
        per_page: 20,
        page: 1,
        q: '',
        sortby: 'transaction.id',
        sortorder: 'desc',

      },
      dataAlbum: [],
      dataSong: [],
      totalAlbum: 0,
      totalSong: 0,
      titlesSong: [{
        prop: 'product',
        label: 'Song Name',
      }, {
        prop: 'amount_credit_text',
        label: 'Amount',
      }, {
        prop: 'amount_artist_cut_text',
        label: 'Artist Cut',
      }, {
        prop: 'amount_musicverse_cut_text',
        label: 'MusicVerse Cut',
      }, {
        prop: 'date',
        label: 'Date',
      }],
      titlesAlbum: [{
        prop: 'product',
        label: 'Album Name',
      }, {
        prop: 'amount_credit_text',
        label: 'Amount',
      }, {
        prop: 'amount_artist_cut_text',
        label: 'Artist Cut',
      }, {
        prop: 'amount_musicverse_cut_text',
        label: 'MusicVerse Cut',
      }, {
        prop: 'date',
        label: 'Date',
      }],
      actionCol: {
        props: {
          label: 'Actions',
        },
        buttons: [{
          props: {
            type: 'primary',
          },
          handler: user => this.detailUser(user),
          label: 'Detail',
        }, {
          // eslint-disable-next-line no-unused-vars
          handler: (row) => {
            this.$message('block success');
          },
          label: 'Block',
        }, {
          // eslint-disable-next-line no-unused-vars
          handler: (row) => {
            this.$message('delete success');
          },
          label: 'Delete',
        }],
      },
      selectedRow: [],
      user: {
        id: '',
        name: '',
        email: '',
        avatar: '',
        country_code: '',
        country_name: '',
        status: '',
        devices: [],
      },
      dataCountries : []
    };
  },
  async mounted() {
    this.dataCountries = this.getCountries();
    this.toggleDashboardProfile(false);
    await this.requestListUserApp(this.filter);
    // this.refineData();
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isFinance', 'isOps']),
    ...mapGetters('UserModule', ['listUserApp', 'listUserSong', 'listUserAlbum', 'getUser']),
  },
  watch: {
    listUserApp: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.refineData();
      },
    },
    listUserSong: {
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.listUserSong.data !== undefined) {
          this.dataSong = this.listUserSong.data.map(song => ({ ...song,
            amount_credit_text: `$${parseFloat(song.amount_credit).toFixed(2)}`,
            date: moment(song.created_at).format('YYYY-MM-DD hh:mm:ss'),
            amount_artist_cut_text: `$${parseFloat(song.amount_artist_cut).toFixed(2)}`,
            amount_musicverse_cut_text: `$${parseFloat(song.amount_musicverse_cut).toFixed(2)}`,
          }));
          this.totalSong = this.listUserSong.total;
        }
      },
    },
    listUserAlbum: {
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.listUserAlbum.data !== undefined) {
          this.dataAlbum = this.listUserAlbum.data.map(song => ({ ...song,
            amount_credit_text: `$${parseFloat(song.amount_credit).toFixed(2)}`,
            date: moment(song.created_at).format('YYYY-MM-DD hh:mm:ss'),
            amount_artist_cut_text: `$${parseFloat(song.amount_artist_cut).toFixed(2)}`,
            amount_musicverse_cut_text: `$${parseFloat(song.amount_musicverse_cut).toFixed(2)}`,
          }));
          this.totalAlbum = this.listUserAlbum.total;
        }
      },
    },
    getUser: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        let status = '';
        switch (val.status) {
          case 1:
            status = 'Active';
            break;
          case 2:
            status = 'Blocked';
            break;
          // eslint-disable-next-line no-fallthrough
          case 0:
          default:
            status = 'Pending';
            break;
        }
        if (val.devices !== undefined && val.devices.length > 0) {
          val.devices = val.devices.map((user) => {
            user.updated_at = user.updated_at ? moment(user.updated_at).format('YYYY-MM-DD hh:mm:ss') : '-';
            user.created_at = user.created_at ? moment(user.created_at).format('YYYY-MM-DD hh:mm:ss') : '-';
            user.is_login = user.is_login ? 'Yes' : 'No';
            return user;
          });
        }
        this.user = Object.assign(this.user, val, { status, verification_last_sent: val.verification_last_sent ? moment(val.verification_last_sent).format('YYYY-MM-DD hh:mm:ss') : '-', type_user: this.user.type == 0 ? 'Free' : 'Subscriber' });
      },
    },
  },
  methods: {
    ...mapActions('UserModule', ['requestListUserApp', 'requestDetailUser',
      'requestDeleteUser', 'requestBlockUser', 'requestUnblockUser', 'requestDetailUserApp',
      'requestListTransactionsUserSong', 'requestListTransactionsUserAlbum', 'requestResendEmail',
    ]),
    toggleTabsUserDetail(tabNumber) {
      this.userDetailOpenTab = tabNumber;
    },
    async searchUser() {
      await this.requestListUserApp(this.filter);
      this.refineData();
    },
    async searchSong() {
      await this.requestListTransactionsUserSong({ filter: { ...this.filterSong, q: this.qwordSong }, user: { id: this.detailUserId } });
    },
    async searchAlbum() {
      await this.requestListTransactionsUserAlbum({ filter: { ...this.filterAlbum, q: this.qwordAlbum }, user: { id: this.detailUserId } });
    },
    async reset() {
      this.$refs.tableUser.$refs.elTable.clearSort();
      this.filter = { q: '', type: '', per_page: 20, page: 1, country_code: '' };
      this.searchUser();
    },
    async resetAlbum() {
      this.$refs.tableAlbum.$refs.elTable.clearSort();
      this.qwordAlbum = '';
      this.searchAlbum();
    },
    async resetSong() {
      this.$refs.tableSong.$refs.elTable.clearSort();
      this.qwordSong = '';
      this.searchSong();
    },
    async detailUser(user) {
      this.detailUserId = user.id;
      await this.requestDetailUserApp(user.id);
      await this.searchAlbum();
      await this.searchSong();
      this.toggleModal();
    },
    toggleAction(event) {
      let popupaction = event.srcElement.closest('.container-action').children[1];
      if (popupaction == null) {
        popupaction = event.srcElement.closest('.container-action').children[0];
      }
      popupaction.classList.toggle('hidden');
    },
    toggleModal() {
      this.isShowingModal = !this.isShowingModal;
      if (!this.isShowingModal) {
        this.$refs.tableSong.$refs.elTable.clearSort();
        this.$refs.tableAlbum.$refs.elTable.clearSort();
        this.qwordAlbum = '';
        this.qwordSong = '';
        this.filterSong = { ...this.filterSong, page: 1, q: '' };
        this.filterAlbum = { ...this.filterAlbum, page: 1, q: '' };
        this.detailUserId = null;
      }
    },
    refineData() {
      if (this.listUserApp.data !== undefined) {
        this.total = this.listUserApp.data.total;
        function onlyUnique(value, index, self) {
          return self.indexOf(value) === index;
        }
        const _this = this;
        this.data = this.listUserApp.data.data.map((user, index) => {
          if (user.devices !== null) {
            const arr_devices = user.devices.split(',');
            const filterDevice = arr_devices.filter(onlyUnique);
            user.devices = filterDevice.join();
          }
          let status = '';
          const statusCode = user.status;
          switch (user.status) {
            case 1:
              status = 'Active';
              break;
            case 2:
              status = 'Blocked';
              break;
            // eslint-disable-next-line no-fallthrough
            case 0:
            default:
              status = 'Pending';
              break;
          }
          if (user.verification_last_sent) {
            user.verification_last_sent = moment(user.verification_last_sent).format('YYYY-MM-DD HH:mm:ss');
          }
          user.created_at = moment(user.created_at).format('YYYY-MM-DD HH:mm:ss');
          user.email_verified_at = user.email_verified_at != null ? moment(user.email_verified_at).format('YYYY-MM-DD HH:mm:ss') : null;
          const type_user = user.type == 0 ? 'Free' : 'Subscriber';

          return Object.assign({}, user, { status, statusCode, seq: ((_this.page - 1) * _this.displayingItem) + index + 1, type_user });
        });
      }
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      this.page = page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = { ...this.filter, per_page: this.displayingItem, sortorder, sortby, page };
      await this.requestListUserApp(this.filter);
    },
    async onChangeTableAlbum(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      this.page = page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'transaction.id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      await this.requestListTransactionsUserAlbum({ filter: { per_page: this.displayingItem, q: this.qwordAlbum, sortorder, sortby, page }, user: { id: this.detailUserId } });
    },
    async onChangeTableSong(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      this.page = page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'transaction.id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      await this.requestListTransactionsUserSong({ filter: { per_page: this.displayingItem, q: this.qwordSong, sortorder, sortby, page }, user: { id: this.detailUserId } });
    },
    async deleteUser(event, row) {
      this.toggleAction(event);
      Vue.swal({
        title: 'Delete Data!',
        text: `Are you sure to delete user: ${row.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          const data = { id: row.id };
          await this.requestDeleteUser({ data, filter: this.filter });
          this.$swal('Deleted', `You successfully delete user: ${row.name}`, 'success');
        }
      });
    },
    async blockUser(event, row) {
      this.toggleAction(event);
      Vue.swal({
        title: 'Block User!',
        text: `Are you sure to block user: ${row.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          const data = { id: row.id };
          await this.requestBlockUser({ data, filter: this.filter });
          this.$swal('Blocked', `You successfully block user: ${row.name}`, 'success');
        }
      });
    },
    async unBlockUser(event, row) {
      this.toggleAction(event);
      Vue.swal({
        title: 'Unblock User!',
        text: `Are you sure to unblock user: ${row.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          const data = { id: row.id };
          await this.requestUnblockUser({ data, filter: this.filter });
          this.$swal('Unblocked', `You successfully unblock user: ${row.name}`, 'success');
        }
      });
    },
    async resendEmail(row) {
      Vue.swal({
        title: 'Resend Email',
        text: `Are you sure to resend email verification to user: ${row.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestResendEmail({ data: { id: row.id }, filter: this.filter });
          this.$swal('Email Send', `Email has successfully send to user: ${row.name}`, 'success');
        }
      });
    },
  },
  components: {
    ModalDialogDetail,
    ViewProfile,
    Card,
    Button,
  },
};
</script>
<style scoped>
.modal-content{
  min-width: 70vw;
}
@media screen and (max-width: 500px){
  .modal-content {
    min-width: unset;
  }
}
.el-table{
  min-height: 400px;
}

</style>



// WEBPACK FOOTER //
// src/views/Users.vue